import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../../../../app/services/account.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LedgerComponent implements OnInit {
  currentUser;
  marginTradeDetails;
  availableBalance;

  constructor(
    private accountSerice: AccountService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    public translate: TranslateService
  ) {}

  goBack() {
    this.router.navigate(['/dashboard']);
  }

  async ngOnInit() {
    try {
      this.currentUser = await this.accountSerice.currentUserAsync();
      this.marginTradeDetails = (localStorage['marginTradeDetails'] && JSON.parse(localStorage['marginTradeDetails'])) || [];
      this.currentUser?.marginTradeDetails?.forEach((row) => {
        row.balance = this.printBalane(row.customerCode);
      });
      this.cdRef.detectChanges();
    } catch (e) {}
  }

  printBalane = (code) => {
    let details = this.marginTradeDetails.find((row) => row.code === code);
    return details?.total || 0;
  };
}
